import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../../Context/AuthContext';
import useRequestHandler from './../useRequestHandler';

const useCreateUser = () => {

    const { t } = useTranslation();
    const { acquireTokenSilently, apiClient } = useContext(AuthContext);
    const { errorHandler, successHandler } = useRequestHandler();
    const [ userExistError, setUserExistError ] = useState(false);

    /** Create user
     * @param {object} user - object discribing the user
     * @example
     * {
     *     "firstName": "",
     *     "lastName": "",
     *     "emailAddress": "",
     *     "isAdminUser": true,
     *     "language": ""
     * }
    */
    const createUser = async (user) => {
        try {

            const accessToken = await acquireTokenSilently();
            
            if (accessToken === "login_required") throw Error("login_required");

            const result = await apiClient.create(accessToken, "users", user);

            return successHandler(result, "useCreateUser", "create", { message: t('success.userCreatedSuccesfully') });

        } catch (error) {
            
            const status = error.status || null;
            const data = error.data || {};
            const errorCode = data.errorCode || 0;

            if (status === 400 && errorCode === -2) setUserExistError(true);

            return errorHandler(error, "useCreateUser", "create");
        }
    }

    return { userExistError, setUserExistError, createUser };

}

export default useCreateUser;
